import { ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SidepanelService {
  private readonly isOpenSource$$ = new ReplaySubject<boolean>(1);
  isOpen$ = this.isOpenSource$$.pipe(startWith(false));
  private readonly headerTitle$$ = new ReplaySubject<string>(1);
  headerTitle$ = this.headerTitle$$.pipe(startWith(''));

  private viewContainerRef?: ViewContainerRef;

  public openSidepanel<T>(content: Type<T>): ComponentRef<T> | undefined {
    this.isOpenSource$$.next(true);
    return this.createView(content);
  }

  public closeSidepanel(): void {
    this.isOpenSource$$.next(false);
    this.viewContainerRef?.clear();
  }

  public setViewContainer(viewContainerRef?: ViewContainerRef): void {
    this.viewContainerRef = viewContainerRef;
  }

  private createView<T>(content: Type<T>): ComponentRef<T> | undefined {
    this.viewContainerRef?.clear();
    return this.viewContainerRef?.createComponent(content);
  }

  public setHeaderTitle(headerTitle: string): void {
    this.headerTitle$$.next(headerTitle);
  }
}
